/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FileStatus {
  FAILED = 'Failed',
  PENDING = 'Pending',
  SUCCESS = 'Success',
  PROCESSING = 'Processing',
}
